const colorsMap = {
	Blanco: '#FFFFFF',
	Negro: '#000000',
	Gris: '#808080',
	Amarillo: '#FFFF00',
	Verde: '#008000',
	Azul: '#0000FF',
	Rojo: '#FF0000',
	Naranja: '#FFA500',
	Morado: '#800080',
	Rosa: '#FFC0CB',
	Beige: '#F5F5DC',
	Crema: '#FFFDD0',
	Celeste: '#87CEEB',
	'Verde Menta': '#98FF98',
	Lila: '#C8A2C8',
	Lavanda: '#E6E6FA',
	Coral: '#FF7F50',
	Salmón: '#FA8072',
	'Azul Marino': '#000080',
	'Verde Oliva': '#808000',
	Vino: '#800000',
	Marrón: '#A52A2A',
	Chocolate: '#D2691E',
	Granate: '#8B0000',
	'Gris Oscuro': '#A9A9A9',
	Dorado: '#FFD700',
	Plateado: '#C0C0C0',
	Bronce: '#CD7F32',
	Cobre: '#B87333',
	Fucsia: '#FF00FF',
	Turquesa: '#40E0D0',
	Esmeralda: '#50C878',
	Limón: '#CCFF00',
	Magenta: '#FF00FF',
	Neón: '#39FF14',
	Terracota: '#E2725B',
	Mostaza: '#FFDB58',
	'Azul Cielo': '#87CEEB',
	'Verde Bosque': '#228B22',
	'Rosa Pastel': '#FFD1DC',
	'Gris Perla': '#D3D3D3',
	'Azul Petróleo': '#013220',
	'Marrón Caramelo': '#AF6E4D',
	'Verde Manzana': '#8DB600',
	'Azul Zafiro': '#0F52BA',
	'Amarillo Girasol': '#FFDA03',
	'Naranja Mandarina': '#FF8800',
	'Marrón Madera': '#DEB887',
	'Rojo Cereza': '#DE3163',
	'Verde Jade': '#00A86B',
} as const

export default colorsMap
